import type { IconName } from '@raiadrogasil/pulso-icons'
import { Icon } from '~/components/icon'
import {
  helperTextLabelErrorVariants,
  helperTextLabelVariants,
  helperTextRoot,
  helperTextVariants,
} from './helper-text.styles'

type IInputSelectHelperTextProps = {
  icon?: IconName
  children: React.ReactNode
  disabled?: boolean
  readonly?: boolean
  error?: boolean
}

export const InputSelectHelperText = ({
  icon,
  children,
  disabled,
  readonly,
  error = false,
}: IInputSelectHelperTextProps) => {
  return (
    <div className={helperTextRoot({ error })}>
      <div className={helperTextVariants({ error, disabled, readonly })}>
        {icon && (
          <div className="flex">
            <Icon
              size="tiny"
              symbol={error ? 'rdicon-warning-circle' : icon}
              color={
                disabled
                  ? 'colorTextNeutralDisabled'
                  : error
                    ? 'colorTextDangerAlternative'
                    : readonly
                      ? 'colorTextNeutralReadonly'
                      : 'colorTextNeutralAlternative'
              }
            />
          </div>
        )}
        <span
          className={
            error ? helperTextLabelErrorVariants() : helperTextLabelVariants()
          }
        >
          {children}
        </span>
      </div>
    </div>
  )
}
